import { useEffect } from "react";

import firebase from "firebase/app";

import { LinearProgress } from "../application/LinearProgress";

export const SignOut =  () => {
    useEffect(() => {
        firebase.auth().signOut();
    }, []);

    return <LinearProgress />;
};
